








import Vue from "vue";
import coreApiClient from "@/services/apis/coreApiClient";
import userManager from "@/services/userManager";
import makeSelectOptions from "@common/util/makeSelectOptions";
import BlurredTenant from '@/components/BlurredTenant.vue';
import { platforms } from "@/constants/platforms";

export default Vue.extend({
  components: { BlurredTenant },
  data() {
    return {
      showBlur: userManager.checkRole(["cpoAdmin", "cpoMonitor"], true) && !!userManager.getUserInfo().tenant?.setting?.expDate && userManager.getUserInfo().tenant.setting.expDate < new Date().getTime(),
      tableOptions: {
        attrs: {
          "item-key": "_id",
          "sort-by": "createdTime",
          "sort-desc": true,
        },
        content: {
          name: "App Version",
          urlEnabled: true,
          search: {
            ext: {
              hidden: true,
            },
          },
          filters: {
            filters: {
              type: {
                type: "selectMultiple",
                attrs: {
                  label: "Platform",
                  items: makeSelectOptions(platforms),
                },
                rules: {
                  match: {},
                },
              },
              version: {
                attrs: {
                  label: "Version",
                },
                rules: {
                  match: {},
                },
              },
            },
          },
          displayFields: {
            platform: {
              text: "Platform",
              sortable: true,
              options: {
                transform(value) {
                    return platforms[value] || value;
                }
              },
            },
            version: {
              text: "Version",
              sortable: true,
            },
            active: {
              text: "Active",
              sortable: true,
              options: {
                label(value) {
                    return (!value && "Disabled") || "Enable";
                },
                attrs(value) {
                    return {
                        color: !value ? "red" : "green",
                    };
                },
              },
            },
            forceUpdate: {
              text: "Force Update",
              sortable: true,
              options: {
                label(value) {
                    return (value && "True") || "";
                },
                attrs(value) {
                    return {
                        color: value ? "orange" : "green",
                    };
                },
              },
            },
            createdTime: {
              text: "Created Time",
              sortable: true,
              options: {
                filter: "dateTime",
              },
            },
            updatedTime: {
              text: "Updated Time",
              sortable: true,
              options: {
                filter: "dateTime",
              },
            },
            action: {
              text: "Actions",
            },
          },
          topActionButtons: {
            insert: userManager.checkRole(["systemAdmin","admin"]) && {},
          },
          template: {
            itemActionButtons: {
              edit: userManager.checkRole(["systemAdmin","admin"]) && {
                target: {
                  dialog: {
                    ext: {
                      subTitleMaker: "licensePlate",
                    },
                  },
                },
              },
              delete: userManager.checkRole(["systemAdmin", "admin"]) && {},
            },
          },
        },
        ext: {
          dataProvider: {
            async findAll(options) {
              const { items, count } = await coreApiClient.call("appVersions", "findAll", options);
              return [items, count];
            },
            async insert(item) {
              return await coreApiClient.call("appVersions", "create", undefined, item);
            },
            async update(item) {
              return await coreApiClient.call(
                "appVersions",
                "update",
                {
                  id: item._id,
                },
                {
                  data: item,
                }
              );
            },
            async delete(item) {
              return await coreApiClient.call("appVersions", "delete", {
                id: item._id,
              });
            },
          },
          default: {
            defaultInputs: {
              platform: {
                type: "select",
                attrs: {
                  label: "Platform",
                  required: true,
                  items: makeSelectOptions(platforms),
                },
              },
              version: {
                attrs: {
                  label: "Version",
                  required: true,
                },
              },
              active: {
                type: "boolean",
                attrs: {
                  label: "Active",
                },
                ext: {
                  defaultValue: true,
                },
              },
              forceUpdate: {
                type: "boolean",
                attrs: {
                  label: "Force Update",
                },
              },
              description: {
                type: "textLarge",
                attrs: {
                  label: "Description",
                },
              },
            },
            insertForm: userManager.checkRole(["systemAdmin","admin"]) && {
              content: {
                fieldNames: [
                  "platform",
                  "version",
                  "description",
                  "forceUpdate",
                  "active",
                ],
              },
            },
            editForm: userManager.checkRole(["systemAdmin","admin"]) && {
              content: {
                fieldNames: [ 
                  "platform",
                  "version",
                  "description",
                  "forceUpdate",
                  "active",],
              },
            },
            delete: {
              confirmDisplayField: "version",
            },
          },
        },
      },
    };
  },
});
